export const EledaMessagesFR = {
  undefinedOrNull: "⍰",
  true: "vrai",
  false: "faux",
  submitBtn: "Valider",
  nextActBtn: "Activité suivante",

  defaultMessageAllSolutionsFound: {
    neutral: ["Bravo, tu as réussi l'activité 🤩"],
    kids: ["Bravo, tu as réussi l'activité 🤩"],
    formal: ["Bravo, vous avez réussi l'activité"],
  },
  defaultMessageAllSolutionsNotFound: {
    neutral: ["Tu n'as pas trouvé toutes les réponses de l'activité."],
    kids: [
      "Tu n'as pas trouvé toutes les réponses de l'activité mais ne te décourage pas 😉",
    ],
    formal: ["Vous n'avez pas trouvé toutes les réponses de l'activité."],
  },

  defaultMessageAllSolutionsNotFoundButRemainedAttempts: {
    neutral: [
      "Tu n'as pas trouvé toutes les réponses de l'activité mais tu peux encore corriger tes réponses.",
    ],
    kids: [
      "Tu n'as pas trouvé toutes les réponses de l'activité mais tu peux encore corriger tes réponses. 😉",
    ],
    formal: [
      "Vous n'avez pas trouvé toutes les réponses de l'activité mais vous pouvez encore corriger vos réponses.",
    ],
  },

  defaultMessageAllSolutionsNotFoundButRemainedQuestions: {
    neutral: [
      "Tu n'as pas trouvé toutes les réponses de l'activité mais il reste encore questions.",
    ],
    kids: [
      "Tu n'as pas trouvé toutes les réponses de l'activité mais il reste encore questions. 😉",
    ],
    formal: [
      "Vous n'avez pas trouvé toutes les réponses de l'activité mais il reste encore questions.",
    ],
  },

  defaultMessageSolutionFound: {
    neutral: [
      "🟢 Bravo, tu as trouvé la bonne réponse.",
      "🟢 C'est correct !",
      "🟢 Encore une bonne réponse !",
      "🟢 C'est une bonne réponse !",
      "🟢 C'est juste !",
      "🟢 Bonne réponse !",
    ],
    kids: [
      "🟢 Bravo, tu as trouvé.",
      "🟢 Waw, c'est correct !",
      "🟢 Encore une bonne réponse ! La grande classe !",
      "🟢 YES, bonne réponse ! Bien joué !",
      "🟢 C'est ça ! Bravo l'artiste !",
      "🟢 Oui ! Continue comme ça !",
      "🟢 Oyé oyé, un nouveau génie des maths est né ! Bonne réponse !",
      "🟢 Woop woop ! Bonne réponse !",
    ],
    formal: [
      "🟢 Bravo, vous avez trouvé la bonne réponse.",
      "🟢 C'est correct !",
      "🟢 Encore une bonne réponse !",
      "🟢 C'est une bonne réponse !",
      "🟢 C'est juste !",
      "🟢 Bonne réponse !",
    ],
  },

  defaultMessageSolutionFoundAtFirstAttempt: {
    neutral: "🟢 Tu as trouvé du premier coup ! Bravo !",
    kids: "🟢 Waouh, tu as trouvé du premier coup !!!",
    formal: "🟢 Vous avez trouvé du premier coup ! Bravo !",
  },

  defaultMessageSolutionNotFound: {
    neutral: [
      "🔴 Tu n'as pas trouvé la solution cette fois.",
      "🔴 C'est une mauvaise réponse.",
      "🔴 Ce n'est pas la bonne réponse.",
    ],
    kids: [
      "🔴 Tu n'as pas trouvé la solution cette fois.",
      "🔴 Mauvaise réponse, zut ! Tu y arriveras la prochaine fois !",
      "🔴 Ce n'est pas la bonne réponse... Un peu plus d’entraînement et tu vas y arriver !",
    ],
    formal: [
      "🔴 Vous n'avez pas trouvé la solution cette fois.",
      "🔴 C'est une mauvaise réponse.",
      "🔴 Ce n'est pas la bonne réponse.",
    ],
  },
  defaultMessageSolutionNotFoundButRemainingAttempts: {
    neutral: [
      "🟠 Tu n'as pas trouvé, essaye encore.",
      "🟠 Mauvaise réponse, dommage ! Essaye encore.",
      "🟠 Mauvaise réponse... Tu peux réessayer.",
      "🟠 Tu n'as pas trouvé, mais tu peux encore corriger ta réponse.",
      "🟠 Mauvaise réponse. Tu y arriveras au prochain essai !",
      "🟠 Ce n'est pas la bonne réponse... Ta prochaine tentative sera peut-être la bonne.",
    ],
    kids: [
      "🟠 Tu n'as pas trouvé, essaye encore.",
      "🟠 Mauvaise réponse, dommage ! Respire un grand coup et concentre-toi, tu vas y arriver !",
      "🟠 Mauvaise réponse... Go go go ! On n'abandonne pas !",
      "🟠 Tu n'as pas trouvé, mais tu peux encore corriger ta réponse.",
      "🟠 Mauvaise réponse, zut ! Tu y arriveras au prochain essai !",
      "🟠 Ce n'est pas la bonne réponse... Ta prochaine tentative sera la bonne !",
      "🟠 Arg, mauvaise réponse ! Allez on ne s'arrête pas là !",
    ],
    formal: [
      "🟠 Vous n'avez pas trouvé, essayez encore une fois.",
      "🟠 Mauvaise réponse ! Essayez encore une fois.",
      "🟠 Mauvaise réponse... Vous pouvez réessayer.",
      "🟠 Vous n'avez pas trouvé la bonne réponse, mais vous pouvez encore corriger votre réponse.",
      "🟠 Mauvaise réponse. Vous y arriverez au prochain essai !",
      "🟠 Ce n'est pas la bonne réponse... Votre prochaine tentative sera peut-être la bonne.",
    ],
  },

  defaultMessageSolution: "La solution est ",

  defaultMessageMCQSolutionAnswer: "est la solution",

  defaultMessageReorderSolutionFound:
    "🟢 Tous les éléments sont bien ordonnés.",
  defaultMessageReorderSolutionNotFound:
    "🔴 Certain(s) élément(s) sont mal placés.",
  defaultMessageAssociateSolutionFound:
    "🟢 Tous les éléments sont bien associés.",
  defaultMessageAssociateSolutionNotFound:
    "🔴 Certain(s) élément(s) sont mal associé(s).",

  questionOpenExpressionDeprecatedMode:
    "Comment écrire une expression mathématique ?",
  questionOpenExpressionDeprecatedModeMathSymbols: `
    Utiliser <b>*</b> pour multiplier. ex: a*b signifie a × b <br/>
    Utiliser <b>/</b> pour les fractions. ex : 1/4 signifie ¼ <br/>
    Utiliser <b>^</b> pour les puissances. ex: a^2 signifie a² <br/>
    Utiliser <b>sqrt()</b> pour les racines carrés. ex: sqrt(a) signifie √a
    `,

  //ERRORS used by manageErrors
  emptyMultipleChoiceQuestion:
    "Erreur de conception : La question ne possède aucun choix",
  emptyQuestionReorder:
    "Erreur de conception : La question ne possède aucun éléments à ordonner",
  emptyQuestionAssociate:
    "Erreur de conception :  La question ne possède aucun éléments à associer",
  notAFractionQuestionFraction:
    "Erreur de conception : la réponse définie dans l'activité semble ne pas être une fraction",
  emptyQuestionOpen:
    "Erreur de conception : Il n'y a pas de solution à cette question",
  notElementBoardQuestionFigure:
    "Erreur de conception : Il n'y a pas de graphique dans cette question",
  notAExpressionQuestionExpression:
    "Erreur de conception : la réponse définie dans l'activité semble ne pas être une expression",
};
